import React, { Component } from 'react';
import {Switch, Route} from 'react-router-dom';
import Login from './pages/login';
import BillReport from './pages/bill/report';
import Layout from './layout';

class App extends Component {
  render() {
    return (
      <Switch>
        <Route path="/" exact component={Login} />
        <Route path="/bill/report" exact component={BillReport} />
        <Route component={Layout} />
      </Switch>
    );
  }
}

export default App;
